<template>
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="form-group col-sm-12 col-md-12 required">
              <label for="account_id">Account:</label>
              <Select2 name="account_id" v-model.number="account_id" :options="accountOptions"/>
            </div>
            <div class="form-group col-sm-12 col-md-6 required">
              <label for="from_date">From Date:</label>
              <input class="form-control" required type="date" v-model="from_date">
            </div>
            <div class="form-group col-sm-12 col-md-6 required">
              <label for="to_date">To Date:</label>
              <input class="form-control" required type="date" v-model="to_date">
            </div>
            <div class="form-group col-sm-12">
              <input class="btn btn-primary" type="submit" value="Show" :disabled="this.onRequest">
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-12">
        <Datatable v-bind:entries="driver_login_data" :columns="columns" :currEntries="100" :title="'Driver Login'"/>
      </div>
      <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
        <img :src="require('../assets/loading.gif')"/>
      </div>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'
  import Datatable from '../components/Datatable.vue'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
        ...mapState('accounts', ['accounts']),
        ...mapState('driver_logins', ['driver_logins', 'onRequest']),
    },
    data(){
      return {
        account_id: '',
        from_date: moment().startOf('month').format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
        default_columns: [
          {name: 'driver_name', text: 'Name'},
          {name: 'driver_code', text: 'Driver Code'},
        ],
        columns: [
          {name: 'driver_name', text: 'Name'},
          {name: 'driver_code', text: 'Driver Code'},
        ],
        accountOptions: [],
        driver_login_data: [],
      }
    },
    components: {
      Datatable,
      Select2,
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        const {account_id, from_date, to_date} = this
        let day = moment(this.from_date).diff(moment(this.to_date), 'days')
        if(day > 0){
          this.error('Please Input Correct Dates.')
          return;
        }

        // if(day < -3){
        //   this.error('Maximum Date Range is 3 days')
        //   return;
        // }

        this.get_data({account_id, from_date: from_date, to_date: to_date + ' 23:59:59'})
      },
      ...mapActions('accounts', ['get_all']),
      ...mapActions('driver_logins', ['get_data', 'clear_data']),
      ...mapActions('alert', ['error', 'clear']),
    },
    created() {
      this.$emit('onChildInit', 'Report Driver Login')
      this.clear_data()
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
          }
          return
        }
      },
      driver_logins(nextState, prevState){
        if(nextState !== prevState){
          if(nextState.length > 0){
            this.driver_login_data = []
            this.columns = [...this.default_columns]
            let days = []
            let date_from = moment(this.from_date)
            let date_to = moment(this.to_date)
            while(date_from <= date_to){
              days.push(date_from.format('YYYY-MM-DD'))
              this.columns.push({text: date_from.format('MM/DD'), name: date_from.format('YYYY-MM-DD')})
              date_from = moment(date_from).add(1, 'day')
            }
            nextState.map(item => {
              let obj = {driver_name: item.driver_name, driver_code: item.driver_code}
              for(let i = 0;i<days.length;i++){
                obj[days[i]] = item.day.includes(days[i]) ? 'on' : 'off'
              }
              this.driver_login_data.push(obj)
            })
          }
          return
        }
      },
    }
  }
</script>
